import React from 'react'
import img1 from "../../assets/OnboardingImages/1.png"
import img2 from "../../assets/OnboardingImages/2.png"
import img3 from "../../assets/OnboardingImages/3.png"
import img4 from "../../assets/OnboardingImages/4.png"
import img5 from "../../assets/OnboardingImages/Train-URL-1.png"
import img6 from "../../assets/OnboardingImages/Train-URL-3.png"
import img7 from "../../assets/OnboardingImages/Train-URL-4.png"
import img8 from "../../assets/OnboardingImages/6.2.png"
import img9 from "../../assets/OnboardingImages/6.1.png"

const GettingStarted = () => {
  return (
    <div className='h-full bg-[#f3f4f6] pr-48'>
    <div className="cursor-default">
      {/* Main Heading */}
     <h1 className="text-3xl font-bold mb-4">Getting Started</h1>

{/* Sign Up Section */}
<h2 className="text-2xl font-semibold mt-6 mb-2">Sign up</h2>
<p className='text-lg'>
  If you are a new Zoi user, below is an overview of the account setup tasks you need to complete to begin.
</p>
<p className="mt-3 text-lg">
  There is only one method to sign up for Zoi: using your registered email ID. For new user registration, enter your <span className='font-bold'>Company Website</span> and <span className='font-bold'>Email</span>. You can start from <a className='text-blue-500' href="https://app.askzoi.ai/signup">here</a>.
</p>
<img className='mt-6 mb-16 border-solid border-2 border-black' src={img1}/>
<p className="mt-3 text-lg">
  You will receive a verification email on your registered ID. Complete the verification process by entering the details and submit.
</p>
<img className='mt-6 mb-16 border-solid border-2 border-black' src={img2}/>
<p className="mt-3 text-lg">Now you are ready to sign in.</p>
<img className='mt-6 mb-16 border-solid border-2 border-black' src={img3}/>

{/* Train Zoi Section */}
<h2 className="text-2xl font-semibold mt-6 mb-2">Train Zoi</h2>
<p className="mt-3 text-lg">
  You can train Zoi about your business product and services, based on which AI will create a competency profile. It will further use this to match information available on the internet and generate leads. There are two main ways you can train Zoi: <span className='font-bold'>Website URLs and Assets</span>.
</p>
{/* Website URL Section */}
<h3 className="text-xl font-semibold mt-4 mb-2">Website URL</h3>
<p className="mt-3 text-lg">
  Starting with <span className='font-bold'>URLs</span>, you can crawl all the relevant website URLs on which you want to train Zoi. We advise you to use pages that are frequently updated and relevant to your offerings.
</p>
<p className="mt-3 text-lg">(It can include Blogs, Case Studies, Products, Pricing, About Us, etc.)</p>
<img className='mt-6 mb-16 border-solid border-2 border-black' src={img4}/>
<p className="mt-3 text-lg">
  Now click on the <strong>Enter URL to Crawl</strong> tab to enter the URLs and also select <strong>Include Sub Pages</strong>. By selecting the subpage inclusion option, Zoi will fetch all your website pages from the website.
</p>
<img className='mt-6 mb-16 border-solid border-2 border-black' src={img5}/>
<p className="mt-3 text-lg">
  You can select all or just a few as per your requirement to train Zoi. Once selected, click on the <strong>Submit to AI</strong> button.
</p>
<img className='mt-6 mb-16 border-solid border-2 border-black' src={img6}/>
<p className="mt-3 text-lg">
  Wait for a few seconds while Zoi starts crawling through all your website pages to gather information for training. Now you are a step closer to getting started.
</p>
<img className='mt-6 mb-16 border-solid border-2 border-black' src={img7}/>

{/* Assets Section */}
<h3 className="text-xl font-semibold mt-4 mb-2">Assets</h3>
<p className="mt-3 text-lg">
  Similarly, you can use assets to train Zoi. Assets are content you have in the form of brochures, leaflets, case studies, etc., which you can upload in the <strong>Train AI</strong> section.
</p>
<p className="mt-3 text-lg">
  This will help give Zoi a better view and understanding of your company’s value proposition, improve signals, and provide relevant leads to your inbox.
</p>
<p className="mt-3 text-lg">
  <strong>Note:</strong> Training effectively will help Zoi prepare a competency profile based on which AI will bring signals that can help you get quality leads and pitch points.
</p>
<p className="mt-3 text-lg">
  To begin, just go to the <strong>Assets</strong> option, and you can either <strong>Upload File</strong> or <strong>Drag and Drop</strong>.
</p>
<img className='mt-6 mb-16 border-solid border-2 border-black' src={img9}/>
<p className="mt-3 text-lg">
  Once you have dragged or uploaded the content, click on the <strong>Upload</strong> button, and the asset gets uploaded. Make sure the assets are in Doc, PDF, or PPT formats only.
</p>
<img className='mt-6 mb-16 border-solid border-2 border-black' src={img8}/>
</div>
    </div>
  )
}

export default GettingStarted